import React from 'react';

import { Box, Button, Grid, Typography, useTheme } from '@mui/material';
import { motion } from 'framer-motion';
import parse from 'html-react-parser';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import StyledIGamingSolution from './styles';

const GamingApi = () => {
    const theme = useTheme();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const label4 = t('gameapi-label-one');
    const label5 = t('gameapi-label-two');
    const label5Mobile = t('gameapi-label-two');
    const gameApis = [
        {
            id: 1,
            title: t('gameapi-title-one'),
            content: t('gameapi-content-one'),
        },
        {
            id: 2,
            title: t('gameapi-title-two'),
            content: t('gameapi-content-two'),
        },
        {
            id: 3,
            title: t('gameapi-title-three'),
            content: t('gameapi-content-three'),
        },
        {
            id: 4,
            title: t('gameapi-title-four'),
            content: t('gameapi-content-four'),
        },
    ];

    return (
        <StyledIGamingSolution>
            <Box className="homeContent">
                <div className="card">
                    <Box sx={{ flex: 1, textAlign: { xs: 'center', md: 'center' }, zIndex: 1 }}>
                        <Typography
                            variant="h2"
                            component="h2"
                            sx={{
                                fontSize: '64px',
                                fontWeight: '900',
                                mb: 4,
                                color: '#000',
                                lineHeight: '76.38px',
                                [theme.breakpoints.down('lg')]: {
                                    mt: 5,
                                    fontSize: '55px',
                                    lineHeight: '65.63px',
                                    fontWeight: 900,
                                },
                            }}
                        >
                            <motion.div
                                initial={{
                                    opacity: 0,
                                    y: 100,
                                }}
                                whileInView={{
                                    opacity: 1,
                                    y: 0, // Slide in to its original position
                                    transition: {
                                        duration: 2, // Animation duration
                                    },
                                }}
                            // viewport={{ once: true }}
                            >
                                {t('gameapi-title')}
                            </motion.div>
                        </Typography>
                        <Box
                            sx={{
                                padding: '0 30px',
                                [theme.breakpoints.down('lg')]: {
                                    padding: 0,
                                },
                            }}
                        >
                            <Typography
                                variant="body1"
                                sx={{
                                    wordWrap: 'break-word',
                                    fontWeight: localStorage.getItem('i18nextLng') === 'en-US' ? '500' : '600',
                                    fontSize: '20px',
                                    color: '#000000',
                                    lineHeight: '23.87px',
                                    [theme.breakpoints.down('lg')]: {
                                        fontSize: '20px',
                                        fontWeight: localStorage.getItem('i18nextLng') === 'en-US' ? '500' : '600',
                                        lineHeight: '23.87px',
                                        display: 'none',
                                    },
                                }}
                            >
                                <motion.div
                                    initial={{
                                        opacity: 0,
                                        y: 100,
                                    }}
                                    whileInView={{
                                        opacity: 1,
                                        y: 0, // Slide in to its original position
                                        transition: {
                                            duration: 2, // Animation duration
                                            delay: 0.8,
                                        },
                                    }}
                                // viewport={{ once: true }}
                                >
                                    {parse(label5)}
                                </motion.div>
                            </Typography>
                            <Typography
                                variant="body1"
                                sx={{
                                    lineHeight: 1.8,
                                    wordWrap: 'break-word',
                                    fontWeight: 700,
                                    fontSize: '20px',
                                    color: '#000000',
                                    lineHeight: '26px',
                                    display: 'none',
                                    [theme.breakpoints.down('lg')]: {
                                        fontSize: '20px',
                                        fontWeight: 600,
                                        lineHeight: '23.87px',
                                        display: 'flex',
                                        justifyContent: 'center',
                                    },
                                }}
                            >

                                <motion.div
                                    initial={{
                                        opacity: 0,
                                        y: 100,
                                    }}
                                    whileInView={{
                                        opacity: 1,
                                        y: 0, // Slide in to its original position
                                        transition: {
                                            duration: 2, // Animation duration
                                            delay: 0.8,
                                        },
                                    }}
                                // viewport={{ once: true }}
                                >
                                    {parse(label5)}
                                </motion.div>
                            </Typography>
                        </Box>
                        <Box
                            justifyContent={'center'}
                            display={{ xs: 'none', sm: 'none', md: 'none', lg: 'flex', xl: 'flex' }}
                            width={'100%'}
                        >
                            <motion.div
                                initial={{
                                    opacity: 0,
                                    y: 100,
                                }}
                                whileInView={{
                                    opacity: 1,
                                    y: 0, // Slide in to its original position
                                    transition: {
                                        duration: 2, // Animation duration
                                        delay: 0.8,
                                    },
                                }}
                            // viewport={{ once: true }}
                            >
                                <Button
                                    variant="contained"
                                    onClick={() => navigate('/contact')}
                                    sx={{
                                        color: '#FFFFFF',
                                        backgroundColor: '#5B3EDE',
                                        borderColor: '#00AA2F',
                                        borderRadius: '4px',
                                        width: '100%',
                                        height: '50px',
                                        marginRight: '30px',
                                        marginTop: 10,
                                        marginBottom: 5,
                                        fontSize: '16px',
                                        fontWeight: 900,
                                        justifyContent: 'center',
                                        display: 'flex',
                                        lineHeight: '19.09px',
                                        [theme.breakpoints.down('lg')]: {
                                            width: '100%',
                                            justifyContent: 'center',
                                            display: 'flex',
                                        },
                                    }}
                                >
                                    {t('gameapi-button')}
                                </Button>
                            </motion.div>
                        </Box>
                        <Box
                            justifyContent={'center'}
                            display={{ xs: 'flex', sm: 'flex', md: 'flex', lg: 'none', xl: 'none' }}
                            width={'100%'}
                        >
                            <motion.div
                                initial={{
                                    opacity: 0,
                                    y: 100,
                                }}
                                whileInView={{
                                    opacity: 1,
                                    y: 0, // Slide in to its original position
                                    transition: {
                                        duration: 2, // Animation duration
                                        delay: 0.8,
                                    },
                                }}
                            // viewport={{ once: true }}
                            >
                                <Button
                                    variant="contained"
                                    onClick={() => navigate('/contact')}
                                    sx={{
                                        color: '#FFFFFF',
                                        backgroundColor: '#5B3EDE',
                                        borderColor: '#00AA2F',
                                        borderRadius: '4px',
                                        width: '142px',
                                        height: '50px',
                                        // marginRight: '30px',
                                        marginTop: 9,
                                        marginBottom: 10,
                                        fontSize: '16px',
                                        fontWeight: 800,
                                        [theme.breakpoints.down('lg')]: {
                                            // width: '100%',
                                            justifyContent: 'center',
                                            display: 'flex',
                                            marginBottom: 5,
                                            marginBottom: 2,
                                        },
                                    }}
                                >
                                    {t('gameapi-button')}
                                </Button>
                            </motion.div>

                        </Box>
                        {/* <Box
                            sx={{
                                padding: '0 30px',
                                [theme.breakpoints.down('lg')]: {
                                    padding: '0',
                                },
                            }}
                        >
                            <Typography
                                variant="body1"
                                sx={{
                                    lineHeight: 1.8,
                                    wordWrap: 'break-word',
                                    fontWeight: 700,
                                    fontSize: '20px',
                                    color: '#676767',
                                    lineHeight: '26px',
                                    [theme.breakpoints.down('lg')]: {
                                        fontSize: '18px',
                                        fontWeight: 600,
                                        lineHeight: '23.4px',
                                        display: 'none',
                                    },
                                }}
                            >
                               <motion.div
                                    initial={{
                                        opacity: 0,
                                        y: 100,
                                    }}
                                    whileInView={{
                                        opacity: 1,
                                        y: 0, // Slide in to its original position
                                        transition: {
                                            duration: 2, // Animation duration
                                            delay: 0.8,
                                        },
                                    }}
                                // viewport={{ once: true }}
                                >
                                {parse(label5)}
                                </motion.div>
                            </Typography>
                            <Typography
                                variant="body1"
                                sx={{
                                    lineHeight: 1.8,
                                    wordWrap: 'break-word',
                                    fontWeight: 700,
                                    fontSize: '20px',
                                    color: '#676767',
                                    lineHeight: '26px',
                                    display: 'none',
                                    [theme.breakpoints.down('lg')]: {
                                        fontSize: '18px',
                                        fontWeight: 600,
                                        lineHeight: '23.4px',
                                        display: 'flex',
                                        justifyContent: 'center',
                                    },
                                }}
                            >
                                <motion.div
                                    initial={{
                                        opacity: 0,
                                        y: 100,
                                    }}
                                    whileInView={{
                                        opacity: 1,
                                        y: 0, // Slide in to its original position
                                        transition: {
                                            duration: 2, // Animation duration
                                            delay: 0.8,
                                        },
                                    }}
                                // viewport={{ once: true }}
                                >
                                {parse(label5Mobile)}
                                </motion.div>
                            </Typography>
                        </Box> */}
                        <Box
                            justifyContent={'center'}
                            sx={{
                                maxWidth: '100%',
                                maxHeight: '100%',
                                padding: '0 0 8% 0',
                                [theme.breakpoints.down('lg')]: {
                                    marginLeft: '15px',
                                },
                            }}
                        >
                            {gameApis.map((item, index) => (
                                <motion.div
                                    initial={{
                                        opacity: 0,
                                        y: 100,
                                    }}
                                    whileInView={{
                                        opacity: 1,
                                        y: 0, // Slide in to its original position
                                        transition: {
                                            duration: 2, // Animation duration
                                            delay: index * 0.3,
                                        },
                                    }}
                                // viewport={{ once: true }}
                                >
                                    <Box
                                        sx={{
                                            maxWidth: '100%',
                                            maxHeight: '100%',
                                            mt: 5,
                                            backgroundColor: '#F7F5F6',
                                            boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
                                        }}
                                        display={'flex'}
                                        key={item.id}
                                    >
                                        <Grid
                                            container
                                            spacing={2}
                                            columnSpacing={0}
                                            display={'flex'}
                                            justifyContent={'space-between'}
                                            sx={{
                                                backgroundColor: '#F7F5F6',
                                                padding: '60px 50px',
                                                borderRadius: '10px',
                                                [theme.breakpoints.down('lg')]: {
                                                    padding: '50px 5px',
                                                    justifyContent: 'center',
                                                },
                                            }}
                                        >

                                            <Grid xs={12} md={12} lg={4} xl={4} textAlign={'left'} justifyContent={'center'} display={'flex'} margin={'1% 0'}
                                                sx={{
                                                    justifyContent: 'left',
                                                    [theme.breakpoints.down('lg')]: {
                                                        justifyContent: 'center',
                                                    },
                                                }}
                                            >
                                                <Typography
                                                    variant="body1"
                                                    sx={{
                                                        lineHeight: '35px',
                                                        wordWrap: 'break-word',
                                                        fontWeight: 900,
                                                        fontSize: '34px',
                                                        color: '#2ba300',
                                                        mr: 1,
                                                        [theme.breakpoints.down('lg')]: {
                                                            fontSize: '25px',
                                                            fontWeight: 900,
                                                            lineHeight: '29.83px',
                                                            textAlign: 'center',
                                                            paddingBottom: '10px',
                                                        },
                                                    }}
                                                >
                                                    {parse(item.title)}
                                                </Typography>
                                            </Grid>
                                            <Grid
                                                xs={12}
                                                md={12}
                                                lg={8}
                                                xl={8}
                                                textAlign={'left'}
                                                sx={{
                                                    [theme.breakpoints.down('lg')]: {
                                                        textAlign: 'center',
                                                    },
                                                }}
                                            >
                                                <Typography
                                                    variant="body1"
                                                    sx={{
                                                        lineHeight: '23.87px',
                                                        wordWrap: 'break-word',
                                                        fontWeight: localStorage.getItem('i18nextLng') === 'en-US' ? '500' : '600',
                                                        fontSize: '20px',
                                                        color: '#676767',
                                                        [theme.breakpoints.down('lg')]: {
                                                            fontSize: '20px',
                                                            fontWeight: localStorage.getItem('i18nextLng') === 'en-US' ? '500' : '600',
                                                            lineHeight: '23.87px',
                                                            padding: '20px 10px',
                                                        },
                                                    }}
                                                >
                                                    {parse(item.content)}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                </motion.div>
                            ))}
                        </Box>
                    </Box>
                </div>
            </Box>
        </StyledIGamingSolution>
    );
};

export default GamingApi;
